import { render, staticRenderFns } from "./prize-preview.vue?vue&type=template&id=242d8ca4&scoped=true"
import script from "./prize-preview.vue?vue&type=script&lang=js"
export * from "./prize-preview.vue?vue&type=script&lang=js"
import style0 from "./prize-preview.vue?vue&type=style&index=0&id=242d8ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d8ca4",
  null
  
)

export default component.exports